module.exports = __webpack_public_path__ + "b890ccc705ab7a39887c93c1c97589cd.svg";


//////////////////
// WEBPACK FOOTER
// ./client/components/svg-logo.svg
// module id = 663
// module chunks = 0